import AgeGate from './../classes/AgeGate';

const ageGate = new AgeGate();
ageGate.init();
